export default "__VITE_ASSET__Cva_Ec0T__"